import React from "react";
import { Card, Layout, Row } from "antd";
import LoginForm from "../components/LoginForm";
import login from "../assets/login.jpg";

const { Content } = Layout;

const Login = () => {
  return (
    <Layout>
      <Content
        style={{
          backgroundImage: `url(${login})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Row justify="center" align="middle" className="page_content">
          <Card style={{ background: "#d0dace69" }}>
            <LoginForm />
          </Card>
        </Row>
      </Content>
    </Layout>
  );
};

export default Login;
